import React, { lazy } from 'react';

const LUFP_V1 = lazy(() => import('./Components/Pages/Splits/LUFP_V1'))
const LUFP_V1B = lazy(() => import('./Components/Pages/Splits/LUFP_V1B'))
const LUFP_OBV1C = lazy(() => import('./Components/Pages/Splits/LUFP_OBV1C'))
const LUFP_V1B_2 = lazy(() => import('./Components/Pages/Splits/LUFP_V1B_2'))
const LUFP_V1B_1 = lazy(() => import('./Components/Pages/Splits/LUFP_V1B_1'))
const LUFP_V1C = lazy(() => import('./Components/Pages/Splits/LUFP_V1C'))
const LUFP_SVY_V2 = lazy(() => import('./Components/Pages/Splits/LUFP_SVY_V2'))
const LUFP_V1B2 = lazy(() => import('./Components/Pages/Splits/LUFP_V1B2'))
const LUFP_TB_V1D = lazy(() => import('./Components/Pages/Splits/LUFP_TB_V1D'))
const LUFP_V5 = lazy(() => import('./Components/Pages/Splits/LUFP_V5'))  
const LUFP_V5_5 = lazy(() => import('./Components/Pages/Splits/LUFP_V5_5'))  
const LUFP_V6 = lazy(() => import('./Components/Pages/Splits/LUFP_V6'))
const LUFP_V5N1 = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1'))
const LUFP_V5N2 = lazy(() => import('./Components/Pages/Splits/LUFP_V5N2'))
const LUFP_V5A = lazy(() => import('./Components/Pages/Splits/LUFP_V5A'))
const LUFP_V5_5A = lazy(() => import('./Components/Pages/Splits/LUFP_V5_5A'))
const LUFP_V5_5B = lazy(() => import('./Components/Pages/Splits/LUFP_V5_5B'))
const LUFP_V5N1_1 = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_1'))
const LUFP_V5N1_1B = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_1B'))
const LUFP_V5N1_1A = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_1A'))
const LUFP_V5N1_1C = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_1C'))
const LUFP_V7A = lazy(() => import('./Components/Pages/Splits/LUFP_V7A'))
const LUFP_V7B = lazy(() => import('./Components/Pages/Splits/LUFP_V7B'))
const LUFP_V5N1_1B2 = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_1B2'))
const LUFP_V5N1_2A = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_2A'));
const LUFP_V8A = lazy(() => import('./Components/Pages/Splits/LUFP_V8A'))
const LUFP_V8B = lazy(() => import('./Components/Pages/Splits/LUFP_V8B'))
const LUFP_V5N1_V9 = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_V9'));
const LUFP_V5N1_V9A = lazy(() => import('./Components/Pages/Splits/LUFP_V5N1_V9A'));
const LUFP_V5C = lazy(() => import('./Components/Pages/Splits/LUFP_V5C'));  
const LUFP_V10 = lazy(() => import('./Components/Pages/Splits/LUFP_V10'));
const LUFP_DF_V12 = lazy(() => import('./Components/Pages/Splits/LUFP_V12'));
const NotFound = lazy(() => import('./Components/Pages/NotFound'));
const LUFP_DF_VA1 = lazy(() => import('./Components/Pages/Splits/LUFP_DF_VA1'));
const RJ_V1 = lazy(() => import('./Components/Pages/Splits/RJ_V1'));
const MCFC_V5 = lazy(() => import('./Components/Pages/Splits/MCFC_V5'));
const AppSplitList = (props) => {

    const SplitListMap = {
        'LUFP_V1': LUFP_V1,
        'LUFP_V1B': LUFP_V1B,
        'LUFP_OBV1C': LUFP_OBV1C,
        'LUFP_V1B_2': LUFP_V1B_2,
        'LUFP_V1B_1': LUFP_V1B_1,
        'LUFP_V1C': LUFP_V1C,
        'LUFP_SVY_V2': LUFP_SVY_V2,
        'LUFP_V1B2': LUFP_V1B2,
        'LUFP_TB_V1D': LUFP_TB_V1D,
        'LUFP_V5': LUFP_V5,
        'LUFP_V5A': LUFP_V5A,
        'LUFP_V5_5': LUFP_V5_5,
        'LUFP_V5_5A': LUFP_V5_5A,
        'LUFP_V5_5B': LUFP_V5_5B,
        'LUFP_V6': LUFP_V6,
        'LUFP_V5N1': LUFP_V5N1,
        'LUFP_V5N2': LUFP_V5N2,
        'LUFP_V5N1_1': LUFP_V5N1_1,
        'LUFP_V5N1_1B':LUFP_V5N1_1B,
        'LUFP_V5N1_1A':LUFP_V5N1_1A,
        'LUFP_V5N1_1C':LUFP_V5N1_1C,
        'LUFP_V7A':LUFP_V7A,
        'LUFP_V7B':LUFP_V7B,
        'LUFP_V5N1_1B2':LUFP_V5N1_1B2,
        'LUFP_V5N1_2A':LUFP_V5N1_2A,
        'LUFP_V8A':LUFP_V8A,
        'LUFP_V8B':LUFP_V8B,
        'LUFP_V5N1_V9':LUFP_V5N1_V9,
        'LUFP_V5N1_V9A':LUFP_V5N1_V9A,
        'LUFP_V5C':LUFP_V5C,
        'LUFP_V10':LUFP_V10,
        'LUFP_DF_V12':LUFP_DF_V12,
        'NotFound': NotFound,
        'LUFP_DF_VA1': LUFP_DF_VA1,
        'oa/RJ_V1': RJ_V1,
        'MCFC_V5': MCFC_V5,
    }
    const SplitComponent = SplitListMap[props.splitName];
    return (
        <>
            {SplitComponent && <SplitComponent />}
        </>
    )

}

export default AppSplitList;